import { Language } from '@/services/graphQL/api/generated/types_web';

export const getSystemLanguage = (): Language => {
  const language = navigator?.language?.split('-')?.[0];
  if (language) {
    const languageCapitalized =
      String(language).charAt(0).toUpperCase() + String(language).slice(1);
    return Language[languageCapitalized as keyof typeof Language] || Language.En;
  }
  return Language.En;
};
